import axios from '@axios'

const BASE = '/workspace/subscription'

export default {
  getPackages: () => axios.get(`${BASE}/packages`),
  getStatus: () => axios.get(`${BASE}/status`),
  getHistory: (params = {}) => axios.get(`${BASE}/history`, { params }),
  toggleAutoRenew: () => axios.post(`${BASE}/toggle-auto-renew`),
  calculate: data => axios.post(`${BASE}/calculate`, data),
  checkout: (data, idempotencyKey = null) => {
    const headers = {}
    if (idempotencyKey) headers['X-Idempotency-Key'] = idempotencyKey
    return axios.post(`${BASE}/checkout`, data, { headers })
  },
  checkTransactionStatus: (txId, { sync = false } = {}) => axios.get(`${BASE}/transaction/${txId}/status`, { params: sync ? { sync: true } : {} }),
  getPendingTransaction: () => axios.get(`${BASE}/pending-transaction`),
  requestVerification: (txId, notes = null) => axios.post(`${BASE}/transaction/${txId}/request-verification`, { notes }),
  getTransactionDetail: (id) => axios.get(`${BASE}/transaction/${id}/detail`),

  /**
   * Verify payment callback token after returning from e-wallet app.
   * Uses public API endpoint (no auth required).
   * @param {string} callbackToken - The callback token from URL query param
   */
  verifyPaymentCallback: callbackToken =>
    axios.post('/public/payment/verify-callback', { callback_token: callbackToken }),
  validateVoucher: data => axios.post(`${BASE}/validate-voucher`, data),
  getEntityAddons: () => axios.get(`${BASE}/addons`),
  pause: () => axios.post(`${BASE}/pause`),
  initiatePayment: (invoiceId, channel) => axios.post(`${BASE}/invoice/${invoiceId}/initiate-payment`, { payment_channel: channel }),
}
